
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sandbox/website-modal",
      function () {
        return require("private-next-pages/sandbox/website-modal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sandbox/website-modal"])
      });
    }
  